var React = require('react');

function IconPromos (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.3333 7.99999C13.3333 7.26666 13.9333 6.66666 14.6667 6.66666V3.99999C14.6667 3.26666 14.0667 2.66666 13.3333 2.66666H2.66668C1.93334 2.66666 1.34001 3.26666 1.34001 3.99999V6.66666C2.07334 6.66666 2.66668 7.26666 2.66668 7.99999C2.66668 8.73332 2.07334 9.33332 1.33334 9.33332V12C1.33334 12.7333 1.93334 13.3333 2.66668 13.3333H13.3333C14.0667 13.3333 14.6667 12.7333 14.6667 12V9.33332C13.9333 9.33332 13.3333 8.73332 13.3333 7.99999ZM10.3867 11.2L8.00001 9.66666L5.61334 11.2L6.33334 8.45332L4.14001 6.65999L6.96668 6.49332L8.00001 3.86666L9.02668 6.49999L11.8533 6.66666L9.66001 8.45999L10.3867 11.2Z","fill":"#A3A1A7"}));
}

IconPromos.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconPromos;

IconPromos.default = IconPromos;
